import { AbstractControl } from '@angular/forms';

export function mmYYFuture(control: AbstractControl) {
  if (control && control.value) {
    const tokens = control.value.split('/');
    if (tokens.length !== 2) {
      return null;
    }
    const m = parseInt(tokens[0], 10);
    const y = parseInt(tokens[1], 10);
    if (isNaN(m) || isNaN(y)) {
      return null;
    }

    const today = new Date();
    const tm = today.getMonth();
    const ty = today.getFullYear() - 2000;

    if (y < ty) {
      return {
        mmYYFuture: true,
      };
    }
    if (y === ty && m < tm) {
      return {
        mmYYFuture: true,
      };
    }
  }
  return null;
}
